import {NameValueDTO} from './NameValueDTO';
import {DataColumnDTO} from './DataColumnDTO';
import {BaseDTO} from './BaseDTO';
import {DataOverrideService} from '../services/data-override.service';

export class DataOverrideDTO extends BaseDTO {
  entityId: number;
  overrideValue: string;
  dataEntityType: NameValueDTO;
  dataColumn: DataColumnDTO;
}

export function CreateDataOverrideDTO(entityId: number, overrideValue: string, dataEntityType: NameValueDTO, dataColumn: DataColumnDTO): DataOverrideDTO {
  const dataOverrideDTO = new DataOverrideDTO();
  dataOverrideDTO.entityId = entityId;
  dataOverrideDTO.overrideValue = overrideValue;
  dataOverrideDTO.dataEntityType = dataEntityType;
  dataOverrideDTO.dataColumn = dataColumn;
  return dataOverrideDTO;
}
